import { JsonSchemaValidator } from "@common/json-schema-validator";
import { LokiStream, lokiStreams } from "@youm-front/loki/domain";

export class LokiPushDTO {
  private static validation = JsonSchemaValidator.compile(
    LokiPushDTO.validationSchema()
  );

  readonly value: LokiPush;

  constructor(value: LokiPush) {
    this.value = JsonSchemaValidator.validate(LokiPushDTO.validation, value);
  }

  toJSON() {
    return this.value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["streams"],
      properties: {
        streams: lokiStreams
      }
    };
  }
}

interface LokiPush {
  streams: LokiStream[];
}
